export default __webpack_public_path__ + "static/media/fechar.b8d6312f.svg";